"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 09 16 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * InternalSiteConverter.
 *
 * @author David Uhlíř
 */


var InternalSiteConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(InternalSiteConverter, _DataObjectConverter_);

  function InternalSiteConverter() {
    _classCallCheck(this, InternalSiteConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(InternalSiteConverter).apply(this, arguments));
  }

  return InternalSiteConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.InternalSiteConverter = InternalSiteConverter;